import Vue from 'vue';
import Router from 'vue-router';
import Layout from '@/layouts/default';

// import others routers
// import Okta Vue SDK
import OktaVue, { LoginCallback } from '@okta/okta-vue';
import { OktaAuth } from '@okta/okta-auth-js';

// import error page
import errorPage from '@/components/boilerplate/errorPage';
import PropertiesRouter from './properties.router';
import ActionPlansRouter from './actionplans.router';
import RootActionsRouter from './rootActions.router';
import RequestsRouter from './requests.router';
import AlertsRouter from './alerts.router';
import DashboardPemRouter from './dashboard-pem.router';
import dashboardDispatcherRouter from './dashboard-dispatcher.router';
// import RegulatoryControlRouter from './regulatory-control.router';

Vue.use(Router);

// set Okta Configuration

const oktaAuth = new OktaAuth({
  pkce: false,
  issuer: process.env.OKTA_ISSUER,
  clientId: process.env.OKTA_CLIENT_ID,
  redirectUri: `${window.location.origin}/implicit/callback`,
  scopes: ['openid', 'profile', 'email'],
});

Vue.use(OktaVue, { oktaAuth });

const PageNotFound = () =>
  import(/* webpackChunkName: "NotFound" */ '@/pages/NotFound.vue');

/*
                  (!!!!!!!!!!!!!!!!!! must set !!!!!!!!!!!!!!!!!!!!!)
* name:'router-name'             the name is used by <router-link> ':to' directive
                                 the value of the 'to' prop will be passed to router.push()
                                 us name route not specific path for handling nested route
                                 (!!!!!!!!!!!!!!!!!! must set !!!!!!!!!!!!!!!!!!!!!)
* meta : {
    title: 'title'               the name show in submenu (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
  }
*/

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/implicit/callback',
      name: 'okta',
      component: LoginCallback,
      beforeEnter: (to, from, next) => {
        if (to.query.iss) {
          next({ name: 'Root' });
        }
        next();
      },
    },
    {
      path: '/error',
      name: 'error',
      component: errorPage,
    },
    {
      path: '*',
      name: 'AllPath',
      redirect: {
        path: '/404',
      },
    },
    {
      path: '/404',
      name: 'NotFound',
      component: PageNotFound,
    },
    {
      path: '/',
      name: 'Root',
      component: Layout,

      // Activate Protected Route
      // Routes are protected by the authRedirectGuard, which verifies
      // there is a valid accessToken or idToken stored.
      // To ensure the user has been authenticated before accessing your route,
      // activate the requiresAuth metadata:

      meta: {
        requiresAuth: true,
      },
      children: [
        PropertiesRouter.getPropertiesRoute(),
        PropertiesRouter.getPropertyRoute(),
        ActionPlansRouter.getActionPlansRoute(),
        ActionPlansRouter.getActionPlanRoute(),
        RootActionsRouter.getActionsRoute(),
        RequestsRouter.getRequestsRoute(),
        AlertsRouter.getAlertsRouter(),
        dashboardDispatcherRouter.getDashboardDispatcherRoute(),
        DashboardPemRouter.getDashboardPemRoute(),
        // RegulatoryControlRouter.getRegulatoryControlRoute(),
      ],
    },
  ],
});

export default router;
